import {
  FACEBOOK_ICON,
  LINKEDIN_ICON,
  LOCATION_ICON,
  MAIL_ICON,
  PINTEREST_ICON,
  TWITTER_ICON,
} from "assets";
import { AnimatePresence, motion } from "framer-motion";
import { ReactSVG } from "react-svg";

const TopBar = ({ isInSidebar, isOpen }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        className={`${isInSidebar ? "in-sidebar" : ""}  page-top-bar`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.5 } }}
        exit={{ opacity: 0 }}
      >
        <div className="container page-top-bar-inner">
          <div className="page-top-bar-inner-left">
            <span className="color-white">
              <ReactSVG src={MAIL_ICON} /> infofinland@gmail.com
            </span>
            <span className="color-white">
              <ReactSVG src={LOCATION_ICON} /> 55 Main Street, 2nd block, New
              York
            </span>
          </div>
          <div className="page-top-bar-inner-right">
            <ReactSVG src={FACEBOOK_ICON} />
            <ReactSVG src={LINKEDIN_ICON} />
            <ReactSVG src={PINTEREST_ICON} />
            <ReactSVG src={TWITTER_ICON} />
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default TopBar;
